import { models, Report } from 'powerbi-client';
import { PowerBIEmbed as PowerBIEmbedComponent } from 'powerbi-client-react';
import React, { useEffect, useMemo, useRef } from 'react';

import styles from './PowerBIEmbed.module.scss';

interface PowerBIEmbedProps {
  embedToken: string;
  reportId: string;
  embedUrl: string;
}

const PowerBIEmbed: React.FC<PowerBIEmbedProps> = ({
  embedToken,
  reportId,
  embedUrl
}) => {
  const reportRef = useRef<Report | null>(null);
  const initialEmbedToken = useRef<string>(embedToken);

  const embedConfig = useMemo(() => {
    return {
      type: 'report',
      id: reportId,
      embedUrl: embedUrl,
      accessToken: initialEmbedToken.current,
      tokenType: models.TokenType.Embed,
      settings: {
        panes: {
          filters: {
            expanded: false,
            visible: false
          },
          pageNavigation: {
            visible: false
          }
        },
        commands: [{
          includeExclude: { displayOption: 1 },
          seeData: { displayOption: 1 }
        }],
        background: models.BackgroundType.Transparent,
      }
    }}, [embedUrl, reportId]);

  const onEmbedded = (embeddedReport: Report) => {
    reportRef.current = embeddedReport;
  };

  // When the parent (InsightsProvider) schedules a fresh token and the query
  // returns it, push the new token into the already-embedded report.
  useEffect(() => {
    if (
      reportRef.current
      && embedToken
    ) {
      reportRef.current.setAccessToken(embedToken);
    }
  }, [embedToken]);

  return (
    <PowerBIEmbedComponent
      embedConfig={embedConfig}
      cssClassName={styles.powerbiEmbed}
      getEmbeddedComponent={(embedObject) => {
        onEmbedded(embedObject as Report);
      }}
    />
  );
};

export default PowerBIEmbed;
